import { ref, unref, watch } from 'vue'
import { v2 } from '@/services/api.js'
import useSalesforceObjectType from '@/composables/useSalesforceObjectType.js'
import snackbar from '@/js/snackbar.js'

const objectId = ref(null)
const loading = ref(false)
const supportCases = ref([])

async function fetch(id) {
  supportCases.value = []
  loading.value = true

  if (unref(id)) {
    supportCases.value = (await v2.get(`${useSalesforceObjectType(unref(id))}/${id}/se-support-cases`)).data
    loading.value = false
  }
}

async function create(data) {
  loading.value = true

  // Creating a promise so that we can emit a close where we physcially save the creation
  return new Promise(async(resolve, reject) => {

    try {
      await v2.post(`${useSalesforceObjectType(objectId.value)}/${objectId.value}/se-support-cases`, data, { 'Content-Type': 'multipart/form-data' })
      resolve()

      snackbar.show({
        tone: 'success',
        heading: 'Success!',
        message: 'SE Support Case successfully created',
        timeout: 3000
      })
    } catch (error) {
      console.log('Error: ', error)
      reject()

      snackbar.show({
        tone: 'failure',
        heading: 'Error creating SE Support Case',
        message: error.message,
        timeout: 5000
      })
    } finally {
      loading.value = false
      // Fetch new data again
      fetch(objectId.value)
    }
  })

}

export default function useCases() {
  return {
    // Variables
    loading,
    supportCases,

    // Functions
    create,
    fetch,
    updateObjectId: (id) => {objectId.value = id},
    updateCasesWhenRouteChanges(route) {
      watch([() => route.params.id, () => route.name], async ([newId, newRoute], [oldId]) => {
        if (newRoute.includes('cases') && newId !== oldId) {
          // Used in the Create Function
          objectId.value = newId
          fetch(newId)
        }
      }, {immediate: true})
    }
  }
}